import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import { DISCUSSION_TYPE_QUESTION } from "@pathwright/web/src/modules/discussion/constants"
import DiscussionForm from "@pathwright/web/src/modules/discussion/form/DiscussionForm"
import Discussions from "@pathwright/web/src/modules/discussion/list"
import {
  DISCUSSION_CONTROL_FILTER_QUESTIONS,
  DISCUSSION_CONTROL_SORT_RECENTLY_ACTIVE
} from "@pathwright/web/src/modules/discussion/list/utils"
import StepDiscussionContainer from "./StepDiscussionContainer"

const StepDiscussionFeed = ({ step, canStartDiscussion, t }) => (
  <StepDiscussionContainer
    step={step}
    canStartDiscussion={canStartDiscussion}
    createTypes={[DISCUSSION_TYPE_QUESTION]}
  >
    {({ context, onStartDiscussion, onSelectDiscussion }) => (
      <Discussions.Container
        context={context}
        onStartDiscussion={onStartDiscussion}
        onSelectDiscussion={onSelectDiscussion}
        filter={DISCUSSION_CONTROL_FILTER_QUESTIONS}
        sort={DISCUSSION_CONTROL_SORT_RECENTLY_ACTIVE}
        initialLoadingCount={0}
      >
        {!!onStartDiscussion && (
          <DiscussionForm
            titleOptions={{
              placeholder: t("What would you like to discuss about this step?")
            }}
          />
        )}
        <Discussions.List />
      </Discussions.Container>
    )}
  </StepDiscussionContainer>
)

StepDiscussionFeed.displayName = "StepDiscussionFeed"

export default withTranslate(StepDiscussionFeed)
